import { ItemRect } from './types';

export const INITIAL_RECT: ItemRect = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

export const getItemRect = (id: string): ItemRect | null => {
  if (typeof document === 'undefined') return null;

  const element = document.querySelector(`[data-handle="${id}-handle"]`);
  const docWidth = document.documentElement.clientWidth;
  const docHeight = document.documentElement.clientHeight;

  if (!element) return null;

  const itemRect = element.getBoundingClientRect();
  return {
    top: itemRect.top,
    left: itemRect.left,
    right: docWidth - itemRect.right,
    bottom: docHeight - itemRect.bottom,
    width: itemRect.width,
    height: itemRect.height,
  };
};
